<script>
import {Bar} from 'vue-chartjs'
import {getPrimaryIncome} from '@/services/dashboard'

const incomeColor = '#63c2de'
const quantityColor = '#c263de'
const convertHex = (hex, opacity) => {
  hex = hex.replace('#', '')
  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)
  return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')'
}

export default {
  extends: Bar,
  props: ['date', 'height'],
  methods: {
    render: function () {
      let date = this.date
      let yearMonth = date.getFullYear() + '-' + (date.getMonth() + 1)
      getPrimaryIncome(yearMonth)
        .then((response) => {
          let data = {
            labels: [],
            quantity: [],
            income: []
          }

          for (let key in response) {
            data.labels.push(key)
            data.quantity.push(response[key].quantity)
            data.income.push(response[key].total)
          }
          return data
        })
        .then((data) => {
          if (this.$data._chart) {
            this.$data._chart.destroy()
          }
          this.renderChart({
            labels: data.labels,
            datasets: [
              {
                label: 'Total Income',
                backgroundColor: convertHex(incomeColor, 10),
                borderColor: incomeColor,
                pointHoverBackgroundColor: '#fff',
                borderWidth: 2,
                data: data.income
              },
              {
                label: 'Total Product Sold',
                backgroundColor: convertHex(quantityColor, 10),
                borderColor: quantityColor,
                pointHoverBackgroundColor: '#fff',
                borderWidth: 2,
                data: data.quantity
              }
            ]
          }, {
            maintainAspectRatio: false,
            legend: {
              display: false
            },
            scales: {
              xAxes: [{
                gridLines: {
                  drawOnChartArea: false
                }
              }],
              yAxes: [{
                ticks: {
                  beginAtZero: true,
                  maxTicksLimit: 5
                },
                gridLines: {
                  display: true
                }
              }]
            },
            elements: {
              point: {
                radius: 0,
                hitRadius: 10,
                hoverRadius: 4,
                hoverBorderWidth: 3
              }
            }
          })
        })
    }
  },
  watch: {
    date () {
      this.render()
    }
  },
  mounted () {
    this.render()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Chart/TypeChart.vue